module.exports = __webpack_public_path__ + "static/media/0223_IMG_LES_MURS_BARDAGE_BOIS_HORIZONTAL.1663b38f.png";